import { StyleRules, Theme } from '@material-ui/core';

export default (theme: Theme): StyleRules => ({
  backButton: {
    width: 'fit-content',
  },
  backImage: {
    height: '20px',
  },
  step: {
    '& .MuiStepIcon-root': {
      '& .MuiStepIcon-text': {
        fill: '#8083A0',
      },
      fill: 'transparent',
    },
    '& .MuiStepIcon-root.MuiStepIcon-active': {
      '& .MuiStepIcon-text': {
        fill: 'white',
      },
      color: '#2E83D9',
      fill: '#2E83D9',
    },
    '& .MuiStepIcon-root.MuiStepIcon-completed': {
      fill: '#2E83D9',
    },
  },
  stepper: {
    backgroundColor: 'transparent',
    padding: 0,
  },
});
